// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__2Fcnx","footer":"ModalFilter_footer__iTdcN"};